import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Caption = () => {
  return (
    <Box padding={{ xs: "25% 0%", sm: "10% 0%" }}>
      <Box width={{ xs: "100%", sm: "75%" }} data-aos={"fade-down"}>
        <Typography
          variant={"h5"}
          fontWeight={500}
          textAlign={"center"}
          paddingTop={"2%"}
          paddingLeft={{ xs: "0%", sm: "12%" }}
          color={"#000"}
        >
          <Typography
            component={"span"}
            color="#33E68C"
            fontWeight={800}
            lineHeight={"1.625em"}
            variant={"h5"}
          >
            OnDesign {""}
          </Typography>
          team is made up of professionals designers and developers that provide
          best results at every stage of our service delivery. We cater for all
          the full branding service, design and software development needs of
          our clients.
        </Typography>
      </Box>
    </Box>
  );
};

export default Caption;
